/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Back_To_CalendarInputs */

const fr_extra_session_back_to_calendar = /** @type {(inputs: Extra_Session_Back_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour au calendrier`)
};

/**

* @param {Extra_Session_Back_To_CalendarInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_back_to_calendar = /** @type {((inputs?: Extra_Session_Back_To_CalendarInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Back_To_CalendarInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_back_to_calendar(inputs)
});